import { createFileRoute, useParams } from '@tanstack/react-router';

import { ExerciseDetailScreen } from '@/features/exercises/components/ExerciseDetailScreen';

export const Route = createFileRoute('/_staff/admin/workspace/exercises/$id/')({
  component: WorkspaceExerciseDetailRoute,
});

function WorkspaceExerciseDetailRoute() {
  const { id } = useParams({ from: '/_staff/admin/workspace/exercises/$id/' });
  return <ExerciseDetailScreen id={id} surface="workspace" />;
}
